/**
 * Left navigation (DashboardSidebar) collapse preference in localStorage.
 * Single key shape per user so Dashboard and StandardPageShell stay in sync.
 *
 * @module sidebarNavStorage
 */

const LEGACY_STANDARD_KEY = 'deutschgenie_standard_sidebar_collapsed';

/**
 * Canonical storage key: matches historical Dashboard key so existing users keep their preference.
 */
export function getNavSidebarStorageKey(userId: string | undefined | null): string {
  return `deutschgenie_dashboard_sidebar_collapsed_${userId ?? 'guest'}`;
}

/**
 * Read collapsed state. Falls back to legacy StandardPageShell key once and migrates to canonical.
 */
export function readNavSidebarCollapsed(userId: string | undefined | null): boolean {
  const canonical = getNavSidebarStorageKey(userId);
  try {
    const v = localStorage.getItem(canonical);
    if (v !== null) {
      return v === '1';
    }
    const legacy = localStorage.getItem(LEGACY_STANDARD_KEY);
    if (legacy !== null) {
      const collapsed = legacy === '1';
      try {
        localStorage.setItem(canonical, collapsed ? '1' : '0');
      } catch {
        /* ignore */
      }
      return collapsed;
    }
  } catch {
    /* ignore */
  }
  return false;
}

/**
 * Persist collapsed state to the canonical key only.
 */
export function writeNavSidebarCollapsed(
  userId: string | undefined | null,
  collapsed: boolean,
): void {
  try {
    localStorage.setItem(getNavSidebarStorageKey(userId), collapsed ? '1' : '0');
  } catch {
    /* ignore */
  }
}
